import { useState, useEffect, useRef } from "react";

const testimonials = [
  {
    name: "Deborah",
    initial: "D",
    color: "#7C3AED",
    date: "March 2026",
    stars: 5,
    title: "Lost 50 lbs — and came back for round 2",
    quote:
      "I signed up last year and lost 50 pounds. I decided to come back and try it for another 3 months. Bryan helped me again. He is AWESOME! Trustworthy and super professional.",
    badge: "🏆 50 lbs lost",
    featured: true,
  },
  {
    name: "Deby D.",
    initial: "DD",
    color: "#059669",
    date: "July 2025",
    stars: 5,
    title: "Lost 11 lbs in just 15 days",
    quote:
      "I had lots of questions and Bryan answered all of them. When there was a problem with shipment he returned my texts immediately. I have lost 11 pounds in 15 days. Bryan made the whole process feel easy and stress-free.",
    badge: "⚡ 11 lbs in 15 days",
    featured: true,
  },
  {
    name: "William B.",
    initial: "WB",
    color: "#D97706",
    date: "March 2026",
    stars: 5,
    title: "Hit my goal — 175 lbs",
    quote:
      "Bryan made everything simple and easy to follow. I've officially reached my goal weight of 175 and couldn't be happier. He was always there to answer questions and guide me.",
    badge: "🎯 Goal achieved",
    featured: true,
  },
  {
    name: "Kim R.",
    initial: "KR",
    color: "#0891B2",
    date: "May 2025",
    stars: 5,
    title: "Down 69 lbs — life changing",
    quote:
      "I'm down 69 pounds and feel like a completely different person. Bryan kept things simple and realistic the whole time. No pressure, just real guidance that worked.",
    badge: "🔥 69 lbs lost",
    featured: true,
  },
  {
    name: "H.H. S.",
    initial: "HH",
    color: "#0891B2",
    date: "March 2026",
    stars: 5,
    title: "Checked many companies — Bryan made it easy",
    quote:
      "Bryan answered every question, email, text and phone call. I checked around with many other companies but he made my decision easy. He explained everything — he is definitely an asset.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Sam K.",
    initial: "SK",
    color: "#DC2626",
    date: "August 2025",
    stars: 5,
    title: "Fantastic — not pushy at all",
    quote:
      "Bryan was fantastic. He has a lot of patience. He answered all my questions and didn't try to rush me. Not pushy at all. I felt really great about my decision.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Denise L.",
    initial: "DL",
    color: "#7C3AED",
    date: "November 2025",
    stars: 5,
    title: "Couldn't have made my life easier",
    quote:
      "I'm so happy and super grateful. Professional and patient — Bryan is a champ. He made the process so fast and simple. I'm older and technically challenged, but Bryan couldn't have made my life easier.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Tiff H.",
    initial: "TH",
    color: "#059669",
    date: "March 2026",
    stars: 5,
    title: "Helped me make the best decision",
    quote:
      "Bryan was amazing — he answered all my questions and concerns and helped me make the best decision.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Tahnee K.",
    initial: "TK",
    color: "#0891B2",
    date: "January 2026",
    stars: 5,
    title: "Thorough, friendly, and made it easy",
    quote:
      "Bryan was thorough and friendly. He made my decision easy to make.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Mary Jane M.",
    initial: "MJ",
    color: "#D97706",
    date: "November 2025",
    stars: 5,
    title: "His kindness is greatly appreciated",
    quote:
      "Bryan was very nice, very knowledgeable, and helped me with the process. He offered to help me with every step. His kindness is greatly appreciated.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Sabrina S.",
    initial: "SS",
    color: "#DC2626",
    date: "February 2026",
    stars: 5,
    title: "Super helpful and professional",
    quote:
      "Bryan was super helpful and professional. I appreciated the time and support he gave me throughout the process.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Isabel V.",
    initial: "IV",
    color: "#7C3AED",
    date: "January 2026",
    stars: 5,
    title: "Clear, efficient, and patient",
    quote:
      "Bryan was clear and efficient with all his help. He was very professional and patient with me. I really appreciate all the time he took making sure I was comfortable.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Rebecca Z.",
    initial: "RZ",
    color: "#059669",
    date: "December 2025",
    stars: 5,
    title: "Bryan was great",
    quote:
      "Bryan was great. He answered all my questions, stepped me through the process, and sent all the links I needed. Looking forward to this journey.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Mike T.",
    initial: "MT",
    color: "#0891B2",
    date: "February 2026",
    stars: 5,
    title: "Got my meds in 2 days",
    quote:
      "It was so simple. I took the quiz, talked with Bryan, and had my medication in just a couple days. Couldn't believe how fast and easy the whole process was. Thank you so much!",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Jason R.",
    initial: "JR",
    color: "#059669",
    date: "January 2026",
    stars: 5,
    title: "Easiest process I've ever done",
    quote:
      "I was nervous at first but Bryan walked me through everything. Took the quiz, had a quick call, and my prescription was handled within days. The whole thing was smoother than I expected.",
    badge: "✅ Verified Client",
    featured: false,
  },
  {
    name: "Linda M.",
    initial: "LM",
    color: "#D97706",
    date: "March 2026",
    stars: 5,
    title: "From quiz to medication in days",
    quote:
      "I filled out the quiz on a Monday and Bryan reached out same day. By Wednesday I had everything sorted. Such a smooth, professional experience. Highly recommend.",
    badge: "✅ Verified Client",
    featured: false,
  },
];

// Inject keyframes + responsive CSS once
const styleTag = `.reviews-stats-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; margin-bottom: 54px; } @media (max-width: 640px) { .reviews-stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; } } .reviews-featured-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 22px; margin-bottom: 24px; } .reviews-regular-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 18px; margin-bottom: 36px; }`;

function injectStyles() {
  if (typeof document !== "undefined" && !document.getElementById("testimonials-styles")) {
    const el = document.createElement("style");
    el.id = "testimonials-styles";
    el.textContent = styleTag;
    document.head.appendChild(el);
  }
}

function StarRating() {
  return (
    <div style={{ display: "flex", gap: "3px" }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#22c55e">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

function useInView(delay = 0) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delay);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return [ref, visible];
}

function FeaturedCard({ t, index }) {
  const [ref, visible] = useInView(index * 140);

  return (
    <div
      ref={ref}
      data-testid={`featured-testimonial-${index}`}
      style={{
        background: "linear-gradient(135deg, rgba(6,78,99,0.92) 0%, rgba(8,47,73,0.96) 100%)",
        borderRadius: "24px",
        padding: "32px",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
        transition: "opacity 0.6s ease, transform 0.25s ease, box-shadow 0.25s ease",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        boxShadow: "0 12px 36px rgba(6, 182, 212, 0.12)",
        border: "1px solid rgba(34, 211, 238, 0.14)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 18px 42px rgba(6, 182, 212, 0.18)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = visible ? "translateY(0)" : "translateY(28px)";
        e.currentTarget.style.boxShadow = "0 12px 36px rgba(6, 182, 212, 0.12)";
      }}
    >
      <div style={{ position: "absolute", top: -10, right: -8, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.05)" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
        <div style={{ width: 48, height: 48, borderRadius: "50%", background: "rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 14, flexShrink: 0, border: "1px solid rgba(255,255,255,0.08)" }}>
          {t.initial}
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>{t.name}</div>
          <div style={{ fontSize: 12, opacity: 0.72 }}>{t.date}</div>
        </div>
        <div style={{ marginLeft: "auto" }}><StarRating /></div>
      </div>

      <div style={{ display: "inline-block", background: "rgba(16, 185, 129, 0.18)", border: "1px solid rgba(52, 211, 153, 0.28)", borderRadius: 999, padding: "6px 14px", fontSize: 13, fontWeight: 700, marginBottom: 14, color: "#d1fae5" }}>
        {t.badge}
      </div>

      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 12, lineHeight: 1.4 }}>{t.title}</div>

      <p style={{ fontSize: 15, lineHeight: 1.8, opacity: 0.88, margin: 0 }}>"{t.quote}"</p>
    </div>
  );
}

function RegularCard({ t, index, isVisible, isHidden }) {
  const [ref, inView] = useInView(index * 80);

  // Card is visible if it's in view AND not in the hidden set
  const showCard = inView && !isHidden;

  return (
    <div
      ref={ref}
      data-testid={`regular-testimonial-${index}`}
      style={{
        background: "rgba(255,255,255,0.96)",
        borderRadius: "18px",
        padding: isHidden ? 0 : "22px",
        boxShadow: isHidden ? "none" : "0 4px 18px rgba(0,0,0,0.06)",
        border: isHidden ? "none" : "1px solid #eef2f7",
        transition: "opacity 0.4s ease, max-height 0.4s ease, padding 0.4s ease, margin 0.4s ease, transform 0.25s ease, box-shadow 0.25s ease",
        opacity: isHidden ? 0 : (showCard ? 1 : 0),
        maxHeight: isHidden ? 0 : 500,
        overflow: "hidden",
        transform: showCard && !isHidden ? "translateY(0)" : "translateY(20px)",
        marginBottom: isHidden ? 0 : undefined,
      }}
      onMouseEnter={(e) => {
        if (!isHidden) {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 10px 26px rgba(0,0,0,0.10)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isHidden) {
          e.currentTarget.style.transform = showCard ? "translateY(0)" : "translateY(20px)";
          e.currentTarget.style.boxShadow = "0 4px 18px rgba(0,0,0,0.06)";
        }
      }}
    >
      {!isHidden && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: t.color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, flexShrink: 0 }}>
              {t.initial}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>{t.name}</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{t.date}</div>
            </div>
            <div style={{ marginLeft: "auto" }}><StarRating /></div>
          </div>

          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            background: "#f0fdf4",
            border: "1px solid #bbf7d0",
            borderRadius: 999,
            padding: "4px 10px",
            fontSize: 11,
            fontWeight: 700,
            color: "#15803d",
            marginBottom: 10,
          }}>
            {t.badge}
          </div>

          <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 8, lineHeight: 1.45 }}>{t.title}</div>

          <p style={{ fontSize: 13, color: "#475569", lineHeight: 1.7, margin: 0 }}>"{t.quote}"</p>
        </>
      )}
    </div>
  );
}

// Google Reviews trust badge
function GoogleReviewsBadge() {
  return (
    <div style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      background: "rgba(255,255,255,0.06)",
      border: "1px solid rgba(255,255,255,0.12)",
      borderRadius: 14,
      padding: "12px 20px",
      marginBottom: 28,
    }}>
      {/* Google G icon */}
      <svg width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>

      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{ fontWeight: 800, fontSize: 15, color: "#f8fafc" }}>5.0</span>
          <div style={{ display: "flex", gap: 2 }}>
            {[1,2,3,4,5].map(i => (
              <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill="#FBBC05">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            ))}
          </div>
          <span style={{ fontSize: 12, color: "#94a3b8", fontWeight: 500 }}>· 16 reviews</span>
        </div>
        <div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>Google Reviews</div>
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  const [showAll, setShowAll] = useState(false);
  const [statsRef, statsVisible] = useInView(0);

  useEffect(() => { injectStyles(); }, []);

  const featured = testimonials.filter((t) => t.featured);
  const regular = testimonials.filter((t) => !t.featured);
  const initialCount = 6; // Show first 6 by default
  const extraCount = regular.length - initialCount;

  const stats = [
    { value: "69 lbs", label: "Top transformation" },
    { value: "11 lbs", label: "In 15 days" },
    { value: "5.0 ★", label: "Avg rating" },
    { value: "500+", label: "Clients guided" },
  ];

  return (
    <section
      data-testid="testimonials-section"
      style={{
        background: "linear-gradient(180deg, #020617 0%, #031633 45%, #04122a 100%)",
        padding: "88px 20px",
        fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <div style={{ maxWidth: "1080px", margin: "0 auto" }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 10, background: "rgba(8, 47, 73, 0.6)", border: "1px solid rgba(34, 211, 238, 0.22)", borderRadius: 999, padding: "10px 18px", marginBottom: 18, color: "#67e8f9" }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#22c55e">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            <span style={{ fontSize: 14, fontWeight: 700 }}>Client Experiences</span>
          </div>

          <h2 style={{ fontSize: "clamp(34px, 5vw, 56px)", fontWeight: 800, color: "#f8fafc", margin: "0 0 14px", lineHeight: 1.08, letterSpacing: "-0.03em" }}>
            Real People. Real Guidance.{" "}
            <span style={{ background: "linear-gradient(90deg, #22d3ee 0%, #22c55e 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Real Results.
            </span>
          </h2>

          <p style={{ fontSize: 18, color: "#94a3b8", margin: "0 auto 10px", maxWidth: 760, lineHeight: 1.6 }}>
            Real client experiences from people Bryan personally guided through their weight loss journey
          </p>
          <p style={{ fontSize: 15, color: "#7dd3fc", margin: "0 0 14px", fontWeight: 500 }}>
            No pressure. No guesswork. Just real guidance.
          </p>
          <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
            Individual results may vary. Not medical advice.
          </p>
        </div>

        {/* Stats bar — now 2-col on mobile */}
        <div ref={statsRef} className="reviews-stats-grid">
          {stats.map((stat, i) => (
            <div
              key={i}
              style={{
                background: "rgba(15, 23, 42, 0.82)",
                border: "1px solid rgba(148, 163, 184, 0.16)",
                borderRadius: 22,
                padding: "22px 18px",
                textAlign: "center",
                transition: `opacity 0.6s ease ${i * 100}ms, transform 0.25s ease, box-shadow 0.25s ease`,
                opacity: statsVisible ? 1 : 0,
                transform: statsVisible ? "translateY(0)" : "translateY(16px)",
                boxShadow: "0 8px 28px rgba(0,0,0,0.14)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.22)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = statsVisible ? "translateY(0)" : "translateY(16px)";
                e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.14)";
              }}
            >
              <div style={{ fontSize: 24, fontWeight: 800, color: "#22d3ee", lineHeight: 1.1, marginBottom: 8 }}>{stat.value}</div>
              <div style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.4 }}>{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Featured cards */}
        <div className="reviews-featured-grid">
          {featured.map((t, i) => (
            <FeaturedCard key={i} t={t} index={i} />
          ))}
        </div>

        {/* All regular cards in ONE unified grid */}
        <div className="reviews-regular-grid">
          {regular.map((t, i) => (
            <RegularCard 
              key={i} 
              t={t} 
              index={i} 
              isVisible={true}
              isHidden={!showAll && i >= initialCount}
            />
          ))}
        </div>

        {/* Show More / Show Less toggle */}
        {extraCount > 0 && (
          <div style={{ textAlign: "center", marginBottom: 46 }}>
            <button
              onClick={() => setShowAll((v) => !v)}
              data-testid="show-more-reviews-btn"
              style={{
                background: "transparent",
                border: "1px solid rgba(148, 163, 184, 0.22)",
                borderRadius: 999,
                padding: "13px 28px",
                fontSize: 14,
                fontWeight: 700,
                color: "#cbd5e1",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(34, 211, 238, 0.5)";
                e.currentTarget.style.color = "#67e8f9";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(148, 163, 184, 0.22)";
                e.currentTarget.style.color = "#cbd5e1";
              }}
            >
              {showAll
                ? "Show Fewer Reviews ↑"
                : `Show ${extraCount} More Reviews ↓`}
            </button>
          </div>
        )}

        {/* CTA block */}
        <div style={{
          background: "linear-gradient(135deg, #082f49 0%, #0f172a 100%)",
          borderRadius: 24,
          padding: "44px 32px",
          textAlign: "center",
          color: "#fff",
          border: "1px solid rgba(34,211,238,0.14)",
          boxShadow: "0 12px 36px rgba(0,0,0,0.22)",
        }}>
          <h3 style={{ fontSize: "clamp(24px, 4vw, 34px)", fontWeight: 800, margin: "0 0 10px", letterSpacing: "-0.02em" }}>
            Ready to See What Your Results Could Look Like?
          </h3>

          <p style={{ fontSize: 16, opacity: 0.82, margin: "0 0 24px", lineHeight: 1.6 }}>
            Get your personalized AI weight loss forecast in just a few minutes
          </p>

          {/* Google Reviews trust badge */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <GoogleReviewsBadge />
          </div>

          <a
            href="/quiz"
            data-testid="testimonials-cta-btn"
            style={{
              display: "inline-block",
              background: "linear-gradient(90deg, #22d3ee 0%, #22c55e 100%)",
              color: "#082f49",
              padding: "16px 36px",
              borderRadius: 999,
              fontWeight: 800,
              fontSize: 16,
              textDecoration: "none",
              boxShadow: "0 8px 26px rgba(34, 197, 94, 0.22)",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
          >
            Get My Free AI Forecast →
          </a>

          <p style={{ fontSize: 12, opacity: 0.56, marginTop: 12, marginBottom: 0 }}>
            Free · 3 minutes · No pressure
          </p>
        </div>

      </div>
    </section>
  );
}
